export const getFileNameFromUrl = (url: string): string => {
  const path = url.split('?')[0].split('#')[0];
  const segment = path.split('/').filter(Boolean).pop() ?? '';
  try {
    return decodeURIComponent(segment) || url;
  } catch {
    return segment || url;
  }
};

export const splitFileName = (
  fileName: string
): { name: string; ext: string } => {
  const dot = fileName.lastIndexOf('.');
  if (dot <= 0 || dot === fileName.length - 1) {
    return { name: fileName, ext: '' };
  }
  return { name: fileName.slice(0, dot), ext: fileName.slice(dot) };
};

export const getFileExtension = (nameOrUrl: string): string => {
  const file = getFileNameFromUrl(nameOrUrl);
  const { ext } = splitFileName(file);
  return ext.slice(1).toLowerCase();
};
